export class RateCharges {
  averageNightlyRate: number;
  price: number;
  serviceCharges: number;
  taxes: number;
  total: number;
  taxesIncludingXPC: number;
  extraPersonCharge: number;

  constructor(avgNightlyRate?: number, price?: number, taxes?: number, total?: number, serviceCharges?: number, extraPersonCharge?: number, taxesIncludingXPC?: number) {
    this.averageNightlyRate = avgNightlyRate;
    this.price = price;
    this.taxes = taxes;
    this.total = total;
    this.serviceCharges = serviceCharges;
    this.extraPersonCharge = extraPersonCharge;
    this.taxesIncludingXPC = taxesIncludingXPC;
  }
}



// WEBPACK FOOTER //
// ./src/main/webapp/stay-mgmt/app/api/model/reservation/rate/rate-charges.model.ts